import { Component, QueryList, ViewChildren, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Asset } from '../../../api/asset/asset';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
    selector: 'asset-page',
    templateUrl: './asset-page.component.html',
    styleUrls: ['./asset-page.component.css'],
    host: {'class': 'page-container'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AssetPageComponent implements AfterViewInit {
  asset: Asset | null = null;
  traceableComponentSources: string[] = ['factory', 'current'];
  choosenTraceableComponentSource: string = "current";
  loading: boolean = false;
  @ViewChildren('tabs') tabs!: QueryList<MatTabGroup>;
  initialTabChange: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private assetApiService: AssetApiService
  ) {
    this.route.params.subscribe(() => {
      const id = this.route.snapshot.paramMap.get('id');
      if (id == null)
        return;

      this.loadAsset(id);
    });
  }

  ngAfterViewInit(): void {
    this.tabs.changes.subscribe(x => {
      const tabIndexText: unknown = window.location.hash?.substring(1);
      const tabIndex: number | null = tabIndexText as number;

      if (tabIndex) {
        this.initialTabChange = true;
        this.tabs.first.selectedIndex = tabIndex;
      }
    })
  }

  loadAsset(assetId: string): void {
    this.loading = true;
    this.assetApiService.getAsset(assetId)
      .subscribe(x => {
        this.asset = x[0];
        this.loading = false;
      });
  }

  tabChanged(index: number): void {
    if (this.initialTabChange) {
      this.initialTabChange = false;
      return;
    }

    const currentPath = this.route.snapshot.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');

    this.location.replaceState(`${currentPath}#${index}`);
  }

  back(): void {
    this.location.back()
  }
}
